module.exports = __webpack_public_path__ + "static/iron_golem-14a370afee20f0e6efe2478615789996.jpg";